<template>
  <div>
    <el-dialog title="整改详情" :visible.sync="visible" width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" @close="handleClose" top="5vh">
      <div class="dialog-content">
        <div class="section-title">整改确认</div>
        <el-table :data="rectificationList" border style="width: 100%" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading">
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column label="项目编号" align="center" prop="testItemChildName" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="不符合情形描述" align="left" prop="unqualifiedDetail" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="整改结果" align="center" min-width="140">
            <template slot-scope="scope">
              <el-select v-model="scope.row.rectificationResult" :disabled="isReadonly" placeholder="" clearable style="width: 100%">
                <el-option label="符合" value="符合"></el-option>
                <el-option label="不符合" value="不符合"></el-option>
                <el-option label="未整改" value="未整改"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="确认方式" align="center" min-width="140">
            <template slot-scope="scope">
              <el-select v-model="scope.row.confirmationMethod" :disabled="isReadonly" placeholder="" clearable style="width: 100%">
                <el-option label="现场确认" value="现场确认"></el-option>
                <el-option label="资料确认" value="资料确认"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="附件上传" align="center" min-width="140">
            <template slot-scope="scope">

              <el-button size="small" type="primary" @click="handlePreview(scope.row)" v-if="scope.row.rectifyConfirmImgUUID != ''">预览</el-button>
              <el-upload v-if="!isReadonly" class="upload-inline" action="#" :http-request="(file) => handleUpload(file, scope.row)" :show-file-list="false" :before-upload="beforeUpload"
                         accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" style="margin-left: 10px;">
                <el-button size="small" type="primary" :loading="scope.row.uploading">
                  {{ scope.row.uploading ? '上传中...' : (scope.row.rectifyConfirmImgUUID ? '重新上传' : '上传附件') }}
                </el-button>
              </el-upload>
              <!-- <div v-if="scope.row.rectifyConfirmImgUUID" class="upload-success-text">
                <i class="el-icon-success" style="color: #67C23A;"></i>
                <span style="color: #67C23A; font-size: 12px;">已上传</span>
              </div> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="!isReadonly" type="primary" @click="handleSubmit" :loading="submitLoading" :disabled="reportState != 'Test'">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 文件预览对话框 -->
    <el-dialog :title="previewTitle" :visible.sync="previewDialogVisible" width="80%" append-to-body :before-close="closePreviewDialog">
      <PdfImgViewer ref="pdfImgViewer" :fileName="currentFileUUID" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreviewDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryByEntrustNum, batchUpdateRectificationInfo, updateRectifyConfirmImgInfo } from '@/api/contract/contract';
import { appjs } from '@/utiljs/apputil';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';

export default {
  name: 'Rectification',
  components: {
    PdfImgViewer
  },
  data () {
    return {
      visible: false,
      loading: false,
      submitLoading: false,
      isReadonly: false,
      source: '',
      entrustNum: '',
      reportState: '',
      rectificationList: [],
      // 文件预览对话框
      previewDialogVisible: false,
      currentFileUUID: '',
      previewTitle: ''
    };
  },
  methods: {
    /**
     * 打开对话框
     * @param {Object} row - 行数据
     */
    openDialog (row, options = {}) {
      this.visible = true;
      this.isReadonly = options.mode === 'view';
      this.source = options.source;
      this.entrustNum = row.entrustNum || row.entrutsNum || '';
      this.reportState = row.reportState
      this.rectificationList = [];
      if (this.entrustNum) {
        this.loadRectificationDetail();
      } else {
        this.$message.warning('委托单编号不能为空');
      }
    },

    /**
     * 加载整改详情
     */
    loadRectificationDetail () {
      this.loading = true;
      const payload = {
        entrustNum: this.entrustNum
      };

      queryByEntrustNum(payload)
        .then(res => {
          this.loading = false;
          if (res && res.retCode === 'ok') {
            const data = res.additionalData || res.data || [];
            this.rectificationList = (Array.isArray(data) ? data : []).map((item, index) => {
              return {
                ...item,
                id: item.id || index,
                projectNum: item.projectNum || item.projectCode || '',
                description: item.description || item.nonconformityDescription || '',
                rectificationResult: item.rectificationResult ? item.rectificationResult : this.source === 'rectificationItem' ? '符合' : '',
                confirmationMethod: item.confirmationMethod ? item.confirmationMethod : this.source === 'rectificationItem' ? '资料确认' : '',
                entrustTestMemoInfoPid: item.entrustTestMemoInfoPid,
                rectifyConfirmImgUUID: item.rectifyConfirmImgUUID || '',
                uploading: false // 添加上传状态标识
              };
            });
          } else {
            this.$message.error((res && res.retMsg) || '获取整改详情失败');
          }
        })
        .catch(error => {
          console.error('获取整改详情失败:', error);
          this.loading = false;
          this.$message.error('获取整改详情失败');
        });
    },

    /**
     * 文件上传前的校验
     */
    beforeUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < 10;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isLt5M;
    },

    /**
     * 自定义文件上传
     */
    handleUpload (fileData, row) {
      const _self = this;
      const formdata = new FormData();
      formdata.append("file", fileData.file);
      const name = fileData.file.name;
      const type = name.substring(name.lastIndexOf(".") + 1);
      formdata.append("fileType", type);

      // 设置上传状态
      _self.$set(row, 'uploading', true);

      appjs.httpRequest('fileupload', formdata, "fileupload", function (event) {
        // 可以在这里显示上传进度
        const progress = ((event.loaded / event.total) * 100).toFixed(0);
        console.log("文件上传中:" + progress + "%");
      }).then((data) => {
        _self.$set(row, 'uploading', false);

        if (data.retCode && data.retCode != "ok") {
          appjs.showErrorMsg(data.retMsg || '文件上传失败');
        } else {
          const fileUUID = data.retMsg;

          // 调用API更新整改确认图片信息
          const updateData = {
            entrustTestMemoInfoPid: row.entrustTestMemoInfoPid,
            rectifyConfirmImgUUID: fileUUID
          };

          updateRectifyConfirmImgInfo(updateData)
            .then(res => {
              if (res && res.retCode === 'ok') {
                // 更新本地数据
                _self.$set(row, 'rectifyConfirmImgUUID', fileUUID);
                appjs.showSuccessMsg("附件上传成功");
              } else {
                appjs.showErrorMsg((res && res.retMsg) || '更新附件信息失败');
              }
            })
            .catch(error => {
              console.error('更新附件信息失败:', error);
              appjs.showErrorMsg("更新附件信息失败");
            });
        }
      }).catch((error) => {
        _self.$set(row, 'uploading', false);
        appjs.showErrorMsg("文件上传异常：" + error);
      });
    },

    // 预览附件
    handlePreview (row) {
      if (!row || !row.rectifyConfirmImgUUID) {
        this.$message.warning('文件不存在');
        return;
      }
      this.currentFileUUID = row.rectifyConfirmImgUUID;
      this.previewTitle = '整改确认附件';
      this.previewDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },

    // 关闭文件预览对话框
    closePreviewDialog () {
      this.previewDialogVisible = false;
      this.currentFileUUID = '';
      this.previewTitle = '';
    },

    /**
     * 关闭对话框
     */
    handleClose () {
      this.visible = false;
      this.resetData();
    },

    /**
     * 重置数据
     */
    resetData () {
      this.entrustNum = '';
      this.isReadonly = false;
      this.rectificationList = [];
      this.closePreviewDialog();
    },

    /**
     * 提交表单
     */
    handleSubmit () {
      // 验证必填项
      const hasEmptyResult = this.rectificationList.some(item => !item.rectificationResult);
      const hasEmptyMethod = this.rectificationList.some(item => !item.confirmationMethod);

      // if (hasEmptyResult) {
      //   this.$message.warning('请填写所有整改结果');
      //   return;
      // }

      // if (hasEmptyMethod) {
      //   this.$message.warning('请填写所有确认方式');
      //   return;
      // }

      // 提交前检查是否存在“不符合”或“未整改”的记录
      const abnormalItems = this.rectificationList.filter(item => {
        return item.rectificationResult === '不符合' || item.rectificationResult === '未整改';
      });

      if (abnormalItems.length > 0) {
        const detailLines = abnormalItems.map((item, index) => {
          const projectCode = item.projectNum || item.testItemChildName || '';
          const reason = item.rectificationResult || '';
          return `${index + 1}、项目编号：${projectCode}，整改结果：${reason}`;
        });

        const message = `检测到以下项目的整改结果为“不符合”或“未整改”：<br/>${detailLines.join('<br/>')}<br/><br/>是否确认继续提交？`;

        this.$confirm(message, '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            this.doSubmit();
          })
          .catch(() => {
            // 用户点击“否”，不进行任何操作
          });
      } else {
        this.doSubmit();
      }
    },

    /**
     * 实际提交到接口的方法
     */
    doSubmit (forceSubmit = false) {
      this.submitLoading = true;

      // 准备提交的数据
      const submitData = this.rectificationList.map(item => {
        return {
          id: item.id,
          entrustNum: this.entrustNum,
          projectNum: item.projectNum,
          rectificationResult: item.rectificationResult,
          confirmationMethod: item.confirmationMethod,
          entrustTestMemoInfoPid: item.entrustTestMemoInfoPid,
          forceSubmit: forceSubmit
        };
      });

      batchUpdateRectificationInfo(submitData)
        .then(res => {
          this.submitLoading = false;
          if (res && res.retCode === 'ok') {
            this.$message.success('提交成功');
            this.handleClose();
            this.$emit('refresh');
          } else if (res && res.retCode === '40013') {
            // 签名限制已移除，不再检查签名状态
            // this.$message.error((res && res.retMsg) || '用户未签名提交失败！');
            // 客户未签名，弹出确认对话框
            // this.$confirm('客户未签名，是否确认提交？', '提示', {
            //   confirmButtonText: '确认提交',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // })
            //   .then(() => {
            //     // 用户确认，强制提交
            //     this.doSubmit(true);
            //   })
            //   .catch(() => {
            //     // 用户取消
            //     this.$message.info('已取消提交');
            //   });
          } else {
            this.$message.error((res && res.retMsg) || '提交失败');
          }
        })
        .catch(error => {
          console.error('提交失败:', error);
          this.submitLoading = false;
          this.$message.error('提交失败');
        });
    }
  }
};
</script>

<style scoped>
.dialog-content {
  max-height: 65vh;
  overflow-y: auto;
  padding: 0 10px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
}

.dialog-footer {
  text-align: right;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

.upload-inline {
  display: inline-block;
}

.upload-success-text {
  margin-top: 5px;
  font-size: 12px;
}
</style>

